<template>
	<div>
		<q-dialog v-model="bsDialog" persistent transition-show="scale" transition-hide="scale">
			<div class="hris-modal" style="max-width: 440px;">
				<div class="hris-modal-header">
					<h2 class="hris-modal-title">Import Basic Salary</h2>
				</div>
				<q-form ref="form" autocomplete="off" @submit="onSubmit">
					<div class="hris-modal-body">
						<label class="hris-form-label">Select file to import</label>
						<input type="file" id="file" ref="file" :rules="[ val => val && val.length > 0 || 'This field is required!']"  v-on:change="handleFileUpload()" required />
					</div>
					<div class="hris-modal-footer">
						<q-btn unelevated class="hris-q-outline" label="Close" @click="closeModal"></q-btn>
						<q-btn unelevated class="hris-q-primary" label="Submit" type="submit"></q-btn>
					</div>
				</q-form>
			</div>
		</q-dialog>

		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius);">
				<q-spinner color="green" size="40px"></q-spinner>
				<span>Uploading…</span>
			</div>
		</q-dialog>
	</div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

	data() {
		return {
			bsDialog:false,
			file:'',
			spinner:false,
		}
	},
	created(){
		this.eventHub.$on('bsDialog', this.importFile);
	},

	methods: {

		importFile:function(payload){
			this.bsDialog = payload.status
		},

		onSubmit:function(){
			this.spinner = true
			let formData  = new FormData();
			formData.append("files", this.file);
			console.log('test',formData);
			axios({
				onUploadProgress: uploadEvent => {
					console.log("Progress: " + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
				},
				headers : {'Authorization' : `Bearer ${this.token}`},
				url:this.apiUrl+'/employee/import/basic',
				data: formData,
				method: 'POST'
			}).then(response => {
				console.log('tes')
				console.log(response)
				setTimeout(() => {
					this.spinner = false
					this.importfile = false
				},500)
				this.eventHub.$emit('refreshEmployeeList');
				this.$q.notify({
						message: 'Successful',
						color: 'green',
						position:'center',
						actions: [
					{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
					]
				})
				this.bsDialog = false
			}).catch((error) => {
				var message = error.response.data.exception[1].message
				var index = message.indexOf("1062");
				var final = message.substring(index + 4);
				this.$q.notify({
					message: final,
					color: 'negative',
					position:'center',
					actions: [
				{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
				]
			})
				this.spinner = false
			})
		},
		handleFileUpload(){
			this.file = this.$refs.file.files[0];
		},

		closeModal:function(){
			this.bsDialog = false
		}
	}
}
</script>
<style lang="css" scoped>
input[type="file"] {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--hris-border);
  border-radius: var(--hris-radius-sm);
  font-family: inherit;
  font-size: 0.875rem;
}
</style>
